export const DEFAULT_FONT_FAMILY = 'Manrope-Regular';
